import './map-viewport.css';
import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

import Scrollbar from 'react-scrollbars-custom';

export default function MapViewport({ children, mapSize, windowSize, handleClick, initialScrollLeft = 0 }) {
	const refScrollbar = useRef(null);

	useEffect(() => {
		if (refScrollbar.current) {
			refScrollbar.current.scrollerElement.scrollTo({
				left: initialScrollLeft,
				top: 0,
				behavior: 'smooth'
			});
		}
	}, [refScrollbar, initialScrollLeft]);

	return (
		<div class="map-viewport-container" onClick={handleClick}>
			<Scrollbar ref={refScrollbar} noDefaultStyles style={{ width: windowSize.width, height: mapSize.height }}>
				{children}
			</Scrollbar>
		</div>
	);
}
